import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUserProjectPreferences } from '../services/getUserProjectPreferences.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadUserProjectPreferences = createAsyncThunk(
  'projects/loadUserProjectPreferences',
  async (arg = {}, { getState }) => {
    const activeEmployerInfo =
      arg.activeEmployerInfo || selectUserActiveEmployerInfo(getState());

    const preferences = await getUserProjectPreferences({
      activeEmployerInfo,
      isLocalApiRequest: arg.isLocalApiRequest,
    });

    return preferences;
  },
  {
    condition: (arg = {}, { getState }) => {
      const state = getState();

      if (state.projects.userProjectPreferencesLoading) {
        return false;
      }

      if (arg.force || arg.shouldRefetch) {
        return true;
      }

      return !state.projects.userProjectPreferencesLoaded;
    },
  }
);
